import { render, staticRenderFns } from "./ForumReply2Icon.vue?vue&type=template&id=9d32087e&scoped=true"
import script from "./ForumReply2Icon.vue?vue&type=script&lang=js"
export * from "./ForumReply2Icon.vue?vue&type=script&lang=js"
import style0 from "./ForumReply2Icon.vue?vue&type=style&index=0&id=9d32087e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d32087e",
  null
  
)

export default component.exports